import React, { useContext, useEffect } from 'react';
import { SypacText } from '@sypac/component-library-react';
import { T } from '@tolgee/react';
import { Link, useLocation } from 'react-router-dom';
import {
	NotificationInterface,
	OrderInterface,
} from '../OrdersTable/interfaces/Order.interface';
import { OrderContext } from '../../context/OrderContext/order.context';
import { AcceptedOrder } from '../../assets/AcceptedOrder';
import { NewOrder } from '../../assets/NewOrder';
import { OrderTarget } from '../OrdersTable/interfaces/OrderStatus.interface';
import { Truck } from '../../assets/Truck';
import productStore from '../../stores/product-store';

export interface NewProductToastProps {
	product: NotificationInterface;
	role: string;
}

const NewProductToast = ({ product, role }: NewProductToastProps) => {
	useEffect(() => {
		productStore.setProductId(product.content?.productId);
	}, []);

	return (
		<Link to="/products" className="no-underline bg-transparent">
			<div className="flex flex-row w-[545px] h-[110px]">
				<div className="flex flex-row justify-center items-center h-12 w-12 min-w-[48px] rounded-10 bg-mountain-meadow-20">
					<NewOrder />
				</div>

				<div className="flex flex-col ml-4 mr-5">
					<div className="flex flex-row justify-start items-center flex-nowrap">
						<SypacText variant="overline-regular-large">
							<p className="text-gray-40 whitespace-nowrap">
								<T keyName={`${role}Toast.productId`}>Product ID:</T>{' '}
								{product.content?.productId}
							</p>
						</SypacText>
					</div>

					<SypacText variant="body-regular-large" className="mt-2">
						<p className="text-gray-80 whitespace-nowrap">
							<T keyName={`${role}Toast.newProduct`}>
								A new product has been added and is pending approval.
							</T>
						</p>
					</SypacText>

					<div className="flex flex-row justify-start flex-nowrap mt-2">
						<div className="flex flex-col justify-start flex-nowrap">
							<SypacText variant="body-regular-small">
								<p className="text-gray-60 whitespace-nowrap">
									<T keyName={`${role}Toast.productName`}>Product name:</T>
								</p>
							</SypacText>
							<SypacText variant="body-regular-small" className="mt-2">
								<p className="text-gray-60 whitespace-nowrap">
									<T keyName={`${role}Toast.companyName`}>Company name:</T>
								</p>
							</SypacText>
						</div>

						<div className="flex flex-col justify-start flex-nowrap ml-3">
							<SypacText variant="body-regular-small">
								<p className="text-gray-60 truncate">
									{product.content?.productName}
								</p>
							</SypacText>
							<SypacText variant="body-regular-small" className="mt-2">
								<p className="text-gray-60 truncate">
									{product.content?.companyName}
								</p>
							</SypacText>
						</div>
					</div>
				</div>
			</div>
		</Link>
	);
};

export default NewProductToast;
